import { ArrowDown, ArrowRight, AlertTriangle } from "lucide-react";
import { formatEuros } from "@/lib/format";

const Case = ({ e }) => (
  <div className="at-card p-4 md:w-[190px] shrink-0 relative overflow-hidden" data-testid={`map-step-${e.code}`}>
    <span className="absolute inset-x-0 top-0 h-1.5" style={{ background: e.temperature || "var(--muted)" }} />
    <p className="font-bold text-sm truncate mt-1">{e.nom}</p>
    <p className="text-2xl font-bold mt-1" data-testid={`map-step-count-${e.code}`}>{e.nombre}</p>
    <p className="text-sm at-muted" data-testid={`map-step-amount-${e.code}`}>{formatEuros(e.montant)}</p>
    <p className="text-xs font-semibold mt-2 flex items-center gap-1" style={{ color: e.sans_action_7j ? "var(--danger)" : "var(--muted)" }} data-testid={`map-step-idle-${e.code}`}>
      <AlertTriangle size={12} />{e.sans_action_7j} sans action &gt; 7 j
    </p>
  </div>
);

const Fleche = ({ pct, code }) => (
  <div className="flex md:flex-col items-center justify-center gap-1 py-1 md:px-1 shrink-0" data-testid={`map-arrow-${code}`}>
    <ArrowDown size={18} className="md:hidden at-muted" /><ArrowRight size={18} className="hidden md:block at-muted" />
    <span className="text-xs font-bold at-pill px-2 py-0.5" style={{ background: "var(--surface-2)" }}>{pct ?? "—"} %</span>
  </div>
);

export const CarteFleches = ({ stats }) => {
  if (!stats) return null;
  return (
    <section className="space-y-4" data-testid="view-carte-fleches">
      <div className="at-soft p-3" data-testid="map-sources">
        <p className="at-label mb-2">Sources qui alimentent « {stats.etapes[0]?.nom} »</p>
        <div className="flex flex-wrap gap-1.5">
          {stats.sources.length === 0 && <span className="text-sm at-muted">Aucune fiche.</span>}
          {stats.sources.map((s) => <span key={s.source} className="px-2.5 py-1 at-pill text-xs font-semibold" style={{ background: "var(--surface)" }}>{s.source} · {s.nombre}</span>)}
        </div>
      </div>
      <div className="flex flex-col md:flex-row md:items-stretch md:overflow-x-auto md:pb-2">
        {stats.etapes.map((e, i) => (
          <div key={e.code} className="flex flex-col md:flex-row md:items-center">
            <Case e={e} />
            {i < stats.etapes.length - 1 && <Fleche pct={e.passage_suivant} code={e.code} />}
          </div>
        ))}
      </div>
      <div className="at-soft p-3" data-testid="map-lost">
        <p className="at-label mb-1">Perdues</p>
        <p className="font-bold" data-testid="map-lost-count">{stats.perdus.nombre} fiche{stats.perdus.nombre > 1 ? "s" : ""}</p>
        {stats.perdus.cause_principale && <p className="text-sm at-muted break-words" data-testid="map-lost-cause">Cause principale : {stats.perdus.cause_principale}</p>}
      </div>
    </section>
  );
};
